import React from "react";
import { useCountdownTimer } from "../hooks/useCountdownTimer";
import { formatTime } from "../utils/timeFormatter";

const TimerDisplay = ({ initialTime, onExpire }) => {
	const timeLeft = useCountdownTimer(initialTime, onExpire);

	return (
		<div className="flex flex-col justify-center items-center">
			<div className="mt-2 text-textSecondary px-4 py-2 mb-4 bg-gray-50 rounded-secondary border border-gray-200 flex flex-row items-center gap-2">
				<div>Reservation Hold For:</div>
				<div>{formatTime(timeLeft)}</div>
			</div>
		</div>
	);
};

TimerDisplay.displayName = "TimerDisplay";

export default TimerDisplay;
